<div class="btn btn-sm btn-secondary mt-5" (click)="displayTos = true">
    Terms of Service
</div>

<p-dialog header="Terms of Service" [(visible)]="displayTos" [modal]="true" [style]="{width: '50vw'}"
    [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <app-terms-and-conditions #tosModalTemplate (close)="displayTos = false"></app-terms-and-conditions>
</p-dialog>